import { render } from "./ExportRegistryModal.vue?vue&type=template&id=4cfc545c"
import script from "./ExportRegistryModal.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ExportRegistryModal.vue?vue&type=script&charset=utf-8&lang=js"

import "./ExportRegistryModal.vue?vue&type=style&index=0&id=4cfc545c&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__